import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { sendNotifications } from '~/api/admin';

/**
 * Mutation to manually trigger a batch of email notifications.
 * This is used for testing purposes locally and in QA environments.
 */
const useSendNotificationBatch = () => { 
  return useMutation(() => {
    return sendNotifications()
      .then(() => {
        toast.success('Successfully sent email notifications');
      }).catch(err => {
        console.error(err);
        toast.error('Error occurred sending notifications. See console logs for more info.');
      });
  });
};

export default useSendNotificationBatch;